import React, { useState,useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {useTheme,Button,Dialog,Typography,FormControl,FormLabel,RadioGroup,FormControlLabel,Radio} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useDropzone } from "react-dropzone";
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import {getListView,massUpdate,importRecords,importRecordsRevert} from "../../../../../../store/actions/module.actions";
import {pathOr} from "ramda";
import { getBase64 } from '../../../../../../common/utils';
import { useDispatch,useSelector } from "react-redux";
import VisibilityIcon from '@material-ui/icons/Visibility';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import FileViewerComp from "../../../../../FileViewer/FileViewer";
import { Skeleton} from '../../../../..';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    minHeight:"50vh"
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function ImportFile({module, visible, toggleVisibility }) {
  const classes = useStyles();
  const currentTheme = useTheme();
  const dispatch = useDispatch();
  const maxFileSize = 5000;
  const [progress, setProgress] = useState(0);
  const [previewFile, setPreviewFile] = useState({open:false,filename:"",filepath:""});
  const [file, setFile] = useState(null);
  const [importType, setImportType] = useState('create');
  const [importStatus, setImportStatus]= useState(null);
  const [loading, setLoading]=useState(false);
  const config = useSelector((state) => state.config);
  const {listViewTabData} = useSelector((state) => state.modules);
  //console.log("listViewTabData",listViewTabData);
  const site_url = pathOr("",["config", "site_url"],config);
  const currentUserId = pathOr("",["currentUserData", "data","id"],config);
  const reqArray = pathOr("",[module,"data","templateMeta","reqArray"],listViewTabData);
 // let furl = `${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=${moduleName}`;

 const rowsPerPage = pathOr(20, ['config', 'list_max_entries_per_page'], config);
  const fileValidation = (file)=>{
    //console.log("valid",file);
    if (file.size > maxFileSize) {
      return {
        code: "name-too-large",
        message: `File size should be less than ${maxFileSize/1024} MB`
      };
    }
  
    return null
  }
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      getBase64(file).then(
        data => setFile(data)
      )
    })
    
  }, [])
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept: ".csv",
    maxFiles:1,
    validator:fileValidation,
    onDrop

  });
  const [selectedFiles, setSelectedFiles] = useState(acceptedFiles);
  
 // console.log("acceptedFiles",acceptedFiles);
  const acceptedFileItems = acceptedFiles.map((file) => (
    <Typography key={file.path}>
      {file.path} - {file.size} bytes
    </Typography>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));
  
 
  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((oldProgress) => {
  //       if (oldProgress === 100) {
  //         return 0;
  //       }
  //       const diff = Math.random() * 10;
  //       return Math.min(oldProgress + diff, 100);
  //     });
  //   }, 500);

  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, [selectedFiles]);

  const sampleExport = async () => {
    try {
      const payload = {
        action:"export_sample",
        data:{
          type:module,
          id:[],
          attributes:[]
        }
      }
      toast("Downloading is in progress...");
      let res = await massUpdate(payload);
      if (res.ok) {
        let content = pathOr(false,["data","data","data","data"],res);
        if(content)
        {
          
          let fileName = pathOr(module,["data","data","data","module"],res);
         // console.log("content",content);
          let csvContent = "data:text/csv;charset=utf-8," + content;
          let encodedUri = encodeURI(csvContent);
          let link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", fileName+".csv");
          document.body.appendChild(link);
          link.click();
        }
      } else {
        toast("Something went wrong!");
      }
    } catch (e) {
      toast("Something went wrong!");
    }
  }
  const  handleShowPreviewFile = (fname) =>{
    let arr = fname.split(".");
    let ext = arr[arr.length-1].toUpperCase();
    let tempNum = Date.now(); //to add extra param to change the url for DocViewer plugin
    //let tempFname = fname.replace(".csv","_"+currentUserId+ext);
    let url = site_url+"/index.php?entryPoint=customDownload&id=ImportErrors&type=import&tempName="+fname+"&isTempFile=1&changeUrlFlag="+tempNum;
   // console.log(url);
    setPreviewFile({open:true,filename:fname,filepath:url,filetype:ext});
  }
  const revertImport = async () =>{
    setLoading(true);
    setImportStatus(null);
    setFile(null);
    let payload = {
      data: {
        type: module,
        import_type:importType,
        attributes: {
        }
      }
    };
    let res = await importRecordsRevert(payload);
    if(res && res.ok)
    {
      dispatch(getListView(module, 0, rowsPerPage,));
      toast(pathOr("Something went wrong!",["data","data","message"],res));
      setLoading(false);
    }else{
      setLoading(false);
      toast("Something went wrong!");
    }
  }
  const submitImport = async()=>{
    setLoading(true);
    let payload = {
      data: {
        type: module,
        import_type:importType,
        attributes: {
          name: [
            {
              file_name: file.name,
              file_content:file.file_content
            }
          ]
        }
      }
    };
    let res = await importRecords(payload);
    if(res.ok)
    {      
      if(res.data.data.status==='failed')
      {
        toast(res.data.data.message);
        setImportStatus(null);
        setFile(null);
        
      }else{
        dispatch(getListView(module, 0, rowsPerPage,));
        setImportStatus(res.data.data);
      }
      setLoading(false);      
    }else{
      setLoading(false);
      toast("Something went wrong!");   
    }
  }
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
      <Dialog disableEscapeKeyDown={false} fullWidth={true} maxWidth={'md'}  aria-labelledby="customized-dialog-title" open={visible}>
        <DialogTitle id="customized-dialog-title" onClose={toggleVisibility}>
          UPLOAD IMPORT FILE
        </DialogTitle>
        <DialogContent dividers>
          {
          !importStatus?<>
          {loading?<Skeleton />:<>
          <Typography gutterBottom variant="body1">
            Select a file on your computer that contains the data that you would like to import, or download the template to get a head start on creating the import file.
          </Typography>
          {
            reqArray && Object.values(reqArray)?
          <Typography gutterBottom variant="body2" color="error">
            Required fields in CSV :  
            {Object.values(reqArray).map((field,key)=><span> {field.replace(":",",")} {Object.values(reqArray).length>1 && Object.values(reqArray).length-1<=key?",":","}</span>)}
            
          </Typography>:""
          }
          <Button color="primary" onClick={sampleExport}>
            Download Import File Template
          </Button>
          
        
          <section className={classes.container}>        
            <div {...getRootProps({ className: classes.dropzone })}>
              <input {...getInputProps()} />
              {
              acceptedFiles.length?
                acceptedFileItems:
                <>
                  <Typography>Click or Drag 'n' drop to select a file </Typography>
                  <Typography>(Only *.csv file is allowed)</Typography>
                </>
              }              
            </div>
            {/* <LinearProgress variant="determinate" value={progress} /> */}
        </section>
        <FormControl component="fieldset">
            <FormLabel component="legend">What would you like to do with imported data?</FormLabel>
            <RadioGroup aria-label="import_type" name="import_type" value={importType} onChange={(e)=>setImportType(e.target.value)}>
              <FormControlLabel value="create" control={<Radio />} label="Create new records only." />
              <FormControlLabel value="update" control={<Radio />} label="Create new records and update existing records" />
            </RadioGroup>
          </FormControl>
        
        </>}</>:<>
        <Typography gutterBottom variant="subtitle1">Total Records Created : {importStatus.data.createdCount}</Typography>
        <Typography gutterBottom variant="subtitle1">Total Records Updated : {importStatus.data.updatedCount}</Typography>
        <Typography gutterBottom variant="subtitle1">Total Records Error : {importStatus.data.errorCount}</Typography>
        <Typography gutterBottom variant="subtitle1">Total Records Duplicate : {importStatus.data.dupeCount}</Typography>
        {importStatus.data.errorCount?
        <Button color="primary" onClick={()=> handleShowPreviewFile(importStatus.data.errorFile.replace("upload://import/",""))}>
          <VisibilityIcon 
            fontSize='small' 
            style={{margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"}} 
            /> 
            View Records with Errors
        </Button>
        :""}
        {importStatus.data.dupeCount?
        <Button color="primary" onClick={()=> handleShowPreviewFile(importStatus.data.dupeFile.replace("upload://import/",""))}>
          <VisibilityIcon className={classes.viewFileIcon} fontSize='small' /> 
            View Duplicate Records
        </Button>:""}
        {importStatus.data.createdCount?
        <Button className={classes.btn} variant="contained"  onClick={revertImport} color="primary">
          <SettingsBackupRestoreIcon fontSize='small' className={classes.viewFileIcon} /> Revert Import
        </Button>:""}
        </>}
        </DialogContent>
        <DialogActions>
          
          {
            !importStatus?
          <>
          <Button className={classes.btn} variant="contained"  onClick={toggleVisibility} color="primary">
            Cancel
          </Button>
          <Button disabled={!file} className={classes.btn} variant="contained" onClick={submitImport} color="primary">
            Upload
          </Button>
          </>
          :
          <>
          <Button className={classes.btn} variant="contained"  onClick={()=>setImportStatus(null)} color="primary">
            Back
          </Button>
          <Button className={classes.btn} variant="contained" onClick={toggleVisibility} color="primary">
            Close
          </Button>
          </>
          }
        </DialogActions>
      </Dialog>
      {(previewFile.open) ? 
        <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
    </MuiThemeProvider>
  );
}

